import { AxiosPromise, AxiosResponse } from 'axios';

import { request } from '@cvt/clients/baseClient';
import { camelizeObject, snakizeObject } from '@cvt/helpers/object';

import { mapUniversityData } from './universityClient.formatter';


const apiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const getUniversities = (params: Universities.GetListParams): AxiosPromise<CVT.Query.PaginatedResults<Universities.University>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/universities/`,
      method: 'GET',
      params: snakizeObject(params),
    },
  }).then((data: AxiosResponse<CVT.Query.PaginatedResults<Universities.UniversityApi>>) => ({
    ...data,
    data: {
      ...data.data,
      results: data.data.results.map(mapUniversityData),
    },
  }));
};

const getUniversity = (params: { id: number }): AxiosPromise<Universities.University> => {
  return request({
    options: {
      url: `${apiBaseUrl}/universities/${params.id}/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Universities.UniversityApi>) => ({
    ...data,
    data: mapUniversityData(data.data),
  }));
};

const likeUniversity = (params: { id: number }): AxiosPromise<Universities.University> => {
  return request({
    options: {
      url: `${apiBaseUrl}/universities/${params.id}/favourite/`,
      method: 'POST',
    },
  }).then((data: AxiosResponse<Universities.UniversityApi>) => ({
    ...data,
    data: mapUniversityData(data.data),
  }));
};

const unlikeUniversity = (params: { id: number }): AxiosPromise<Universities.University> => {
  return request({
    options: {
      url: `${apiBaseUrl}/universities/${params.id}/unfavourite/`,
      method: 'POST',
    },
  }).then((data: AxiosResponse<Universities.UniversityApi>) => ({
    ...data,
    data: mapUniversityData(data.data),
  }));
};

const ignoreUniversity = (params: { id: number }): AxiosPromise<Universities.University> => {
  return request({
    options: {
      url: `${apiBaseUrl}/universities/${params.id}/ignore/`,
      method: 'POST',
    },
  }).then((data: AxiosResponse<Universities.UniversityApi>) => ({
    ...data,
    data: mapUniversityData(data.data),
  }));
};

const getUniversitySpecialization = (params: { university: number, specialization: number }): AxiosPromise<Universities.Specialization[]> => {
  return request({
    options: {
      url: `${apiBaseUrl}/universities/${params.university}/specialization/${params.specialization}/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Universities.SpecializationApi[]>) => ({
    ...data,
    data: data.data.map(camelizeObject<Universities.SpecializationApi>),
  }));
};

const applyToUniversity = (data: { university: number, specialization?: number }): AxiosPromise<void> => {
  return request({
    options: {
      url: `${apiBaseUrl}/universities/${data.university}/apply/`,
      method: 'POST',
      data,
    },
  });
};

export const universityClient = {
  getUniversities,
  getUniversity,
  likeUniversity,
  unlikeUniversity,
  ignoreUniversity,
  applyToUniversity,
  getUniversitySpecialization,
};
